import React from "react";
import { Container, SpaceBetween, Box, Link } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";

const ResourcesSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        title="Resources"
        variant="h2"
        icon={<Icon name="globe" />}
        useGradient={true}
      />
      <Container variant="stacked">
        <SpaceBetween size="s">
          <Box fontWeight="heavy">
            <Link
              href="https://news.a2z.com/search/overview?query=WWASF+Newsletter"
              variant="secondary"
              fontSize="heading-xs"
              target="_blank"
            >
              WWASF Newsletter
            </Link>
          </Box>
          <Box fontWeight="heavy">
            <Link
              href="https://fgbs.na.lego.a2z.com/consumer-finance"
              variant="secondary"
              fontSize="heading-xs"
              target="_blank"
            >
              WWASF A to Z page
            </Link>
          </Box>
          <Box fontWeight="heavy">
            <Link
              href="https://broadcast.amazon.com/channels/5177"
              variant="secondary"
              fontSize="heading-xs"
              target="_blank"
            >
              WWASF Broadcast channel
            </Link>
          </Box>
          <Box fontWeight="heavy">
            <Link
              href="https://amzn-fgbs.slack.com/archives/C02KCMHTK2B"
              variant="secondary"
              fontSize="heading-xs"
              target="_blank"
            >
              wwasf-connect Slack channel
            </Link>
          </Box>
        </SpaceBetween>
      </Container>
    </Box>
  );
};

export default ResourcesSection;
